export const SUMMARY_STEP_CONTENT_TEST_ID = 'summary-step-content-test-id';
